import { createSelector } from 'reselect';

import type { SpartacuxProductDiscoveryDomainState } from '../../productDiscovery.model';
import {
  selectProductRecommendationConfigs,
  selectProductRecommendations,
} from './productRecommendation';
import * as translations from './translations';

// ENGINES

export const frequentlyBoughtTogetherEngineName = 'FrequentlyBoughtTogether';

// ENGINE LIST

export const frequentlyBoughtTogetherEngineList = [
  frequentlyBoughtTogetherEngineName,
];

// SELECTORS

export const selectFrequentlyBoughtRecommendationsConfig = createSelector(
  [selectProductRecommendationConfigs],
  (recommendationConfigs) =>
    recommendationConfigs?.find(
      (reco) =>
        reco.engineName &&
        frequentlyBoughtTogetherEngineList.includes(reco.engineName),
    ),
);

export const selectFrequentlyBoughtRecommendations = createSelector(
  [
    selectProductRecommendations,
    (
      state: Partial<SpartacuxProductDiscoveryDomainState>,
      displayCustomTitle?: boolean,
    ) => displayCustomTitle,
  ],
  (recommendations, displayCustomTitle) => {
    let playlist = recommendations?.find(
      (reco) =>
        reco.engineName &&
        frequentlyBoughtTogetherEngineList.includes(reco.engineName),
    );

    if (displayCustomTitle && playlist) {
      playlist = {
        ...playlist,
        title: translations.oftenPurchasedTogether,
      };
    }

    return playlist;
  },
);
